const IconPositionEnum=
{
    None:'None',
    Left:'Left',
    Right:'Right',
    Center:'Center',
};

export default IconPositionEnum;